import { useEffect, useState, useCallback } from "react";
import { useAuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import favoriteProfiles from "../../apis/favoriteProfiles";
import FirmLogo from "../Images/FirmLogo";
import BlockHeader from "../Headers/BlockHeader";
import { AlertInfo } from "../Alerts/Alert";
import ComponentLoader from "../Loader/ComponentLoader";

const MyFavorite = () => {
  const { userDetails } = useAuthContext();
  const firm_id = JSON.parse(userDetails)?.firm_details?.firm_id;
  const user_slug = JSON.parse(userDetails)?.user_slug;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(false);

  const getFavoriteProfiles = useCallback(() => {
    Promise.all([favoriteProfiles(user_slug)])
      .then(async ([data]) => {
        if (data?.data?.status === 1) {
          setIsLoading(false);
          setData(data?.data?.result);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [user_slug, setData, setIsLoading]);

  useEffect(() => {
    if (user_slug !== undefined) {
      getFavoriteProfiles();
    }
  }, [user_slug, getFavoriteProfiles]);

  const displayProfileName = (item) => {
    if (firm_id !== "" && firm_id !== undefined) {
      if (firm_id === item.firm_id) {
        return (
          <span className="fw-semibold text-truncate text-decoration-none text-dark">
            {item.profile_name}
          </span>
        );
      } else {
        return (
          <span className="fw-semibold text-truncate text-decoration-none text-secondary">
            Name Withheld
          </span>
        );
      }
    } else {
      return (
        <span className="fw-semibold text-truncate text-decoration-none text-secondary">
          Name Withheld
        </span>
      );
    }
  };

  const displayJobRole = (role) => {
    if (role !== null && role.trim().length !== 0) {
      return <span className="text-primary text-sm">{role}</span>;
    }
  };

  const displayList = () => {
    return (
      <div className="table-responsive table-wrapper scrollable">
        <table className="table table-bordered">
          <thead className="no-border">
            <tr className="border-top-0">
              <th>Name</th>
              <th>Firm</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index.toString()}>
                <td>
                  <Link to={"resources/details/" + item.user_slug}>
                    {displayProfileName(item)}
                    <div>{displayJobRole(item.user_profile_role)}</div>
                  </Link>
                </td>

                <td className="align-middle">
                  <FirmLogo url={item.firm_logo} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const displayContent = () => {
    if (!data) {
      return <AlertInfo message="Nothing to display here!" />;
    } else {
      return displayList();
    }
  };

  const checkIsLoading = () => {
    if (isLoading) {
      return <ComponentLoader />;
    } else {
      return displayContent();
    }
  };

  return (
    <div class="card">
      <div className="card-body">
        <BlockHeader
          title={"My Favorites"}
          subText={"Profiles you have flagged as favorites"}
        />

        {checkIsLoading()}
      </div>
    </div>
  );
};

export default MyFavorite;
